/** @jsxImportSource @emotion/react */
import Navbar from '@app/components/ui/Navbar/Navbar'
import SidebarTrigger from '@app/components/ui/Sidebar/SidebarTrigger'
import { clientNameAtom } from '@app/state/clientsAtom'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

const PropertyNavbar = () => {
  const clientName = useAtomValue(clientNameAtom)

  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])
  return (
    <Navbar.Wrapper>
      <SidebarTrigger color="gray" />
      <Navbar.List>
        <span />
      </Navbar.List>
      <Navbar.Logo>
        <img src={logos.full} alt="Logo" />
      </Navbar.Logo>
    </Navbar.Wrapper>
  )
}

export default PropertyNavbar
